import { useTheme } from "@/context/ThemeContext";
import DualPaneView from "../components/DualPaneView";
import { cardDataMap } from "../data";
import ExperienceShell from "../ExperienceShell";

export default function BaziExperiencePage() {
  const { effectiveTheme } = useTheme();

  return (
    <ExperienceShell activeId="bazi" contentKey="bazi">
      <DualPaneView data={cardDataMap.bazi} isLight={effectiveTheme === "light"} />
    </ExperienceShell>
  );
}
